module.exports = __webpack_public_path__ + "img/logo.dd435108.png";